export default "__VITE_ASSET__66b349ac__"